module.exports = __webpack_public_path__ + "img/error-image.d3025f4.png";